export const testimonialContent = {
  max: {
    body:
      'Thanks for providing me with a clear choice of my Medicare options. You quickly made a complex and confusing system understandable saving me time and money!',
    person: 'Max K. - Palo Alto, CA',
  },
  patti: {
    body:
      'Daniel Petkevich is an awesome insurance agent for many reasons. I needed guidance for signing up for a Medicare Supplement plan and he was so good at explaining all the different options and figuring out what was best for me.',
    person: 'Patti B. - San Rafael, CA',
  },
  staci: {
    body:
      "You have made turning 65 a bit more tolerable and we are definitely going to enjoy our raise.   Yes, you are our guy and we will pass your info on.  Don't let this go to your head but you are a 10!!!!!",
    person: 'Stacey G. - Orange, CA',
  },
  chip: {
    body:
      "Daniel's common-sense approach and analogies of putting on layers of health insurance stood out from the deluge of mailings and emails I received in the months leading up to my medicare enrollment.",
    person: 'Chip K. - Canyon Country, CA',
  },
}
